import './sectionHead.css'

const SectionHead = (props) => {
	return (
		<div className={`section__head ${props.divclassName}`}>
			<span>{props.icon}</span>
			<h2>{props.title}</h2>
		</div>
	)
}

export default SectionHead

